import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentPreviewMediaFragmentFragmentDoc } from '../../../../services/yi/queries/ContentPreviewMediaFragment.generated'
import { ContentFeatureMediaFragmentFragmentDoc } from '../../../../services/yi/queries/ContentFeatureMediaFragment.generated'
import { Content_ProviderCommonFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderCommonFragment.generated'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
import { Content_ProviderMetadataFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderMetadataFragment.generated'
export type YiSeriesEpisode_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  title?: string | null
  path?: string | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  description?: string | null
  descriptionFormat?: string | null
  productType?: string | null
  language?: string | null
  primaryLanguage?: string | null
  seasonNumber?: number | null
  episodeNumber?: number | null
  contentPolicyPolicyId?: number | null
  previewMediaId?: string | null
  featureMediaId?: string | null
  contentProvider?: {
    __typename?: 'ContentProvider'
    provider?: Types.ContentProviderProviders | null
    providerKey?: string | null
    contentId?: string | null
  } | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiSeries?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentFrom?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      title?: string | null
      language?: string | null
      primaryLanguage?: string | null
    } | null> | null
  } | null> | null
  previewMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export const YiSeriesEpisode_ContentFragmentFragmentDoc = gql`
  fragment YISeriesEpisode_ContentFragment on Content {
    id
    contentId
    contentType
    published
    publishedAtDate
    createdAt
    updatedAt
    title
    path
    shortDescription
    shortDescriptionFormat
    description
    descriptionFormat
    productType
    language
    primaryLanguage
    seasonNumber
    episodeNumber
    productType
    ...ContentPreviewMediaFragment
    ...ContentFeatureMediaFragment
    contentProvider {
      provider
      providerKey
      ...Content_ProviderCommonFragment
    }
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiSeries: contentReferencesTo(types: ["yi-series-episode"]) {
      id
      contentReferenceType {
        type
      }
      contentFrom {
        id
        contentId
        contentType
        published
        title
        language
        primaryLanguage
      }
    }
    ...Content_ProviderMetadataFragment
  }
  ${ContentPreviewMediaFragmentFragmentDoc}
  ${ContentFeatureMediaFragmentFragmentDoc}
  ${Content_ProviderCommonFragmentFragmentDoc}
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
